import * as React from 'react';
import cn from 'clsx';

import { withDeviceType, IWithDeviceTypeProps } from '../../utils/withDeviceType';

import * as styles from './styles.css';

interface ISectionProps extends IWithDeviceTypeProps {
  /** С отступами над и под секцией? */
  withVerticalMargins?: boolean;
  /** С полями по бокам секции? */
  withHorizontalPaddings?: boolean;
  withMaxWidth?: boolean;
  withPositionRelative?: boolean;
  /** Фон секции */
  background?: React.CSSProperties['background'];
  /** Содержимое секции */
  children: React.ReactNode;
  /** data-name для тестов */
  dataName?: string;

  forwardRef?: React.Ref<HTMLElement>;
}

/**
 * Компонент-обертка над основными секциями на странице.
 * По-умолчанию задает вертикальные отступы и горизонтальные поля. Задает максимальную ширину контенту.
 */
const Section: React.FC<React.PropsWithChildren<ISectionProps>> = ({
  withVerticalMargins = true,
  withHorizontalPaddings = true,
  withMaxWidth = true,
  withPositionRelative = false,
  background,
  children,
  deviceType,
  dataName,
  forwardRef,
}) => {
  return (
    <section
      ref={forwardRef}
      className={cn(styles['section'], styles[deviceType], {
        [styles['with-vertical-margins']]: withVerticalMargins,
        [styles['with-horizontal-paddings']]: withHorizontalPaddings,
      })}
      style={{ background }}
      data-name={dataName}
    >
      <div
        className={cn(styles['section-inner'], {
          [styles['with-max-width']]: withMaxWidth,
          [styles['with-position-relative']]: withPositionRelative,
        })}
      >
        {children}
      </div>
    </section>
  );
};

const SectionWithDeviceType = withDeviceType(Section);
export { SectionWithDeviceType as Section };
